import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {EmbedComponent} from '@app/embed/embed/embed.component';

const routes: Routes = [{ path: 'embed/:assetId', component: EmbedComponent }];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class EmbedRoutingModule {}
